import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { RejectWorkInviteParams } from '@/features/work/api/reject-work-invite/request';
import { rejectWorkInvite } from '@/features/work/api/reject-work-invite/request';

export const useRejectWorkInviteMutation = (
  settings?: MutationSettings<RejectWorkInviteParams, typeof rejectWorkInvite>
) =>
  useMutation({
    mutationKey: ['CreateWorkInvite'],
    mutationFn: ({ params, config }) =>
      rejectWorkInvite({
        params,
        config
      }),
    ...settings?.options
  });
